import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  originalFile: null,
  compressedFile: null,
  compressionLevel: 0.8,
  originalSize: 0,
  compressedSize: 0,
  compressionRatio: 0,
  isCompressing: false,
  error: null,
}

const imageCompressorSlice = createSlice({
  name: 'imageCompressor',
  initialState,
  reducers: {
    setOriginalFile: (state, action) => {
      state.originalFile = action.payload
      state.originalSize = action.payload?.size || 0
      state.compressedFile = null
      state.compressedSize = 0
      state.compressionRatio = 0
      state.error = null
    },
    setCompressionLevel: (state, action) => {
      state.compressionLevel = action.payload
    },
    setCompressing: (state, action) => {
      state.isCompressing = action.payload
    },
    setCompressedFile: (state, action) => {
      state.compressedFile = action.payload
      state.compressedSize = action.payload?.size || 0
      if (state.originalSize > 0) {
        state.compressionRatio = ((state.originalSize - state.compressedSize) / state.originalSize * 100).toFixed(1)
      }
    },
    setError: (state, action) => {
      state.error = action.payload
      state.isCompressing = false
    },
    clearCompressorState: (state) => {
      state.originalFile = null
      state.compressedFile = null
      state.originalSize = 0
      state.compressedSize = 0
      state.compressionRatio = 0
      state.isCompressing = false
      state.error = null
    },
  },
})

export const {
  setOriginalFile,
  setCompressionLevel,
  setCompressing,
  setCompressedFile,
  setError,
  clearCompressorState,
} = imageCompressorSlice.actions

export default imageCompressorSlice.reducer
